import { DCNT721A } from './DCNT721A'
import { DCNTSeries } from './DCNTSeries'
import { ERC721Generic } from './ERC721Generic'
import { legacy } from './legacy'

export const ABI = { ERC721Generic, DCNTSeries, DCNT721A, legacy }
